import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { ListAction } from "src/app/models/list-actions.model";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { SweetAlertOptions } from "sweetalert2";
import { AlertasService } from "../alertas.service";

@Component({
  selector: "app-modal-asignar",
  templateUrl: "./modal.component.html",
})
export class AlertaProgramadasModal implements OnInit {
  public defaults?: any = undefined;
  public actions: ListAction<any>[] = [
    {
      desc: "Eliminar",
      action: "delete",
      color: "text-red-600",
      icon: "far fa-trash-alt",
      visible: (row) => !row.Enviado,
    },
  ];

  public columns: ListColumn[] = [
    {
      name: "Fecha Envio",
      property: "FechaEnvio",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Enviado",
      property: "Enviado",
      visible: true,
      isModelProperty: false,
      transform: (val) => {
        return val == "true" ? "✅" : "📅";
      },
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];
  list: any[] = [];
  first = true;

  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;
  private askRemoveConfig: SweetAlertOptions = {
    title: "Seguro que quieres eliminar este registro?",
    text: "Esta accion es irreversible!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si",
    cancelButtonText: "No",
  };

  constructor(
    public service: AlertasService,
    private alerts: AlertasSwalService,
    public dialogRef: MatDialogRef<AlertaProgramadasModal>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  ngOnInit(): void {
    this.loadRecords();
  }

  loadRecords() {
    this.service.getProgramadas(this.data.IdAlertasRegistro).subscribe(
      (resultData) => {
        this.tableComp.setData(resultData);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  actionstable(e: { action: string; row: any }) {
    if (e.action == "delete") {
      this.askRemove(e.row);
    }
  }

  askRemove(row: any) {
    this.alerts.ask(this.askRemoveConfig).then((result) => {
      if (result.isConfirmed) {
        this.eliminar(row);
      }
    });
  }

  eliminar(row: any) {
    this.service.deleteProgramada(row.IdAlertasProgramadas).subscribe(
      (next) => {
        this.alerts.correcta("Eliminado", "Accion realizada correctamente");
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  } 
}
